<template>
  <b-modal class="modal-lg" id="posthouseModal" ref="posthouse-modal" :title="posthouseModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary"  @show="fetchAdditionalInfo()" @hide="resetModal('main'); clearModal();">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'home']" size="1x" class="mr-2"/> {{ posthouseModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="vld-parent text-center">
        <div autofocus>
          <!--<div @transitioncancel="loaderStopped">-->
            <loading
            :active.sync="modalIsBusy"
            :can-cancel="false"
            :color="'#047bf8'"
            :loader="'dots'"
            :is-full-page="false"></loading>
          <!--</div>-->
          <div v-if="!modalIsBusy" >
            <template v-if="posthouseModal.docuData.docsChecked && posthouseModal.docuData.docsChecked.length">
              <template v-if="posthouseModal.docuData.posthousesDetails.length">
                <h5 class="py-2">{{ t('overView','overView') }}</h5>
                <table v-if="posthouseModal.docuData.posthousesDetails" class="table info-table">
                  <tr class="bg-primary text-white">
                    <td>{{ t('labelPostHouse','labelPostHouse') }}</td>
                    <td>{{ t('labelNumOfDocs','labelNumOfDocs') }}</td>
                  </tr>

                  <template v-for="posthouse in posthouseModal.docuData.posthousesDetails">
                    <tr>
                      <td>{{ posthouse.name }}</td>
                      <td>{{ posthouse.number_of_docs }}</td>
                    </tr>
                  </template>
                </table>
              </template>
              <h5 class="py-2">{{ t('detail','detail') }}</h5>
              <table class="table info-table">
                  <tr class="bg-primary text-white">
                    <td>{{ t('labelDoc','labelDoc') }}</td>
                    <td>{{ t('labelDocRef','labelDocRef') }}</td>
                    <td>{{ t('labelPostHouse','labelPostHouse') }}</td>
                  </tr>
                <template v-for="docInfo in posthouseModal.docuData.documentDetails">
                  <tr>
                    <td>{{ docInfo.id }}</td>
                    <td>{{ docInfo.reference }}</td>
                    <td>{{ docInfo.post_house }}</td>
                  </tr>
                </template>
              </table>
              <table v-if="posthouseModal.docuData.notOutsourced" class="table info-table">
                  <tr>
                    <td>{{ t('labelNotOutsourced','labelNotOutsourced') }}</td>
                    <td>{{ posthouseModal.docuData.notOutsourced }}</td>
                  </tr>
              </table>
              <!--<p class="text-primary">{{t('changePostHouseForAllAbove','changePostHouseForAllAbove')}}</p>-->
              <h5 class="py-2">{{ t('changePostHouseForAllAbove','changePostHouseForAllAbove') }}</h5>
              <b-form-select v-model="newPostHouse" :options="postHouses" :select-size="4"></b-form-select>
            </template>
            <template v-else>
              <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
              <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
            </template>
          </div>
        </div>
      </div>
      <ResponseInfo v-if="getResponseInfo.responseName == 'documentsView'"></ResponseInfo>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="posthouseModal.docuData.docsChecked && posthouseModal.docuData.docsChecked.length">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" aria-label="ChangePosthouse" data-dismiss="modal" class="btn btn-primary" type="button" :disabled="!newPostHouse" @click="changePostHouse()">
          {{ t('submitButtonText', 'submitButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Loading from 'vue-loading-overlay'


export default {
  name: 'ModalChangePostHouse',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal',
    'modalCreator',
    'searchDocuments',
    'userLevel',
    'clientName'
  ],
  data () {
    return {
      newPostHouse: '',
      posthouseModal: {},
      buttonIsBusy: false,
      modalIsBusy: true,
      loaderBusy: true
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    postHouses() {
      return ['CrownFTP', 'DatacoreSFTP', 'DatenPartner', 'DatenPartnerSFTP', 'DHL', 'Greens', 'IMC', 'Netsend', 'PML', 'TMP', 'WebbMason', 'YamagataPrinthubSFTP']
    },
    /*
    newpostHouses: {
      get(){
        return this.$store.getters['documentsStore/getAvailablePosthouses']
      }
    },*/
    documentsInfo: {
      get(){
        return this.$store.getters['documentsStore/getDocumentsInfoForPosthouseChange']
      }
    },
    posthousesDetails: {
      get(){
        return this.$store.getters['documentsStore/getPosthousesDetails']
      }
    },
    notOutsourced: {
      get(){
        return this.$store.getters['documentsStore/getNotOutsourced']
      }
    }
  },
  methods:{
    clearModal() {
      this.newPostHouse = ''
      this.buttonIsBusy = false
      this.modalIsBusy = true
      this.loaderBusy = true
    },
    /*
    loaderStopped() {
      this.loaderBusy = false
    },*/
    fetchAdditionalInfo() {
      //clear previous response
      this.$store.dispatch('alertClearResponse')
      this.modalIsBusy = true
      this.loaderBusy = true
      //this.$store.dispatch('documentsStore/getAvailablePostHouses')
      if(this.posthouseModal.docuData.docsChecked.length) {
        this.$store.dispatch('documentsStore/getPostHousesInfoForPostHouseChange',{
          documents: this.posthouseModal.docuData.docsChecked
        })
        .then(() => {
          this.posthouseModal.docuData.posthousesDetails = this.posthousesDetails
          this.posthouseModal.docuData.notOutsourced = this.notOutsourced
        })
        this.$store.dispatch('documentsStore/getDocumentsInfoForPosthouseChange',{
          documents: this.posthouseModal.docuData.docsChecked
        })
        .then(() => {
          this.posthouseModal.docuData.documentDetails = this.documentsInfo
          this.modalIsBusy = false
        })
      }else {
        this.modalIsBusy = false
        this.loaderBusy = false
      }
    },
    changePostHouse() {
      this.buttonIsBusy = true
      this.$store.dispatch('documentToolsStore/handleDocumentTool',{
        action: 'changePosthouse',
        documents: this.posthouseModal.docuData.docsChecked,
        newPostHouse: this.newPostHouse
      })
      .then(() => {
        this.buttonIsBusy = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.$refs['posthouse-modal'].hide()
          if(responseStatus != 'noChange') {
            this.searchDocuments()
          }
        }
      })
    }
  },
  created() {
    this.posthouseModal = this.$attrs.modal

    //this.posthouseModal.docuData.documentDetails = {}
  },
  filters:{
    humanReadable: function(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  },
  components:{
    ResponseInfo,
    Loading
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
.modal-open #notifyModal___BV_modal_outer_ >>> .modal-content{
  min-width: 850px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #notifyModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 520px;
  overflow-y: scroll;
}
</style>
